import { api } from '@/api';

//role: [AGENT, RECOMMENDER]

const getMyRefferalAccountsPyramid = () => api.get('/api/kyc/v1/investor/pyramid/down');

const getMyRecommenderAccounts = () => api.get('/api/kyc/v1/investor/recommenders');

const getMyAgentAccounts = () => api.get('/api/kyc/v1/investor/agents');

const requestRefferalCode = (role) =>
  api.post('/api/kyc/v1/investor/requestCheckReferralCode', { role });
const requestSetAgent = (code) =>
  api.post('/api/kyc/v1/investor/requestCheckRole', { role: 'AGENT', referralCode: code });
const requestSetAssistant = (code) =>
  api.post('/api/kyc/v1/investor/requestCheckRole', { role: 'RECOMMENDER', referralCode: code });

export const investorReferralApi = {
  getMyRefferalAccountsPyramid,
  getMyRecommenderAccounts,
  getMyAgentAccounts,
  requestRefferalCode,
  requestSetAgent,
  requestSetAssistant
};

export const investorReferralKeys = {
  getRefferalAccountsPyramid: 'investor.getMyRefferalAccountsPyramid',
  getRecommendersAccounts: 'investor.getMyRecommenderAccounts',
  getAgentAccounts: 'investor.getMyAgentAccounts'
};
